import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { api } from "../lib/api";
import { setToken, setUser } from "../lib/auth";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("admin");
  const [p, setP] = useState("");
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { username: u, password: p });
      setToken(res.data.access_token, { remember });
      setUser(res.data.user, { remember });
      toast.success("Welcome back");
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen hero-gradient grid place-items-center p-4">
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-elevated max-w-md w-full p-7" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-1">
          <Logo size={40} tone="auto" />
          <div>
            <div className="font-bold text-navy">Melopa Invents</div>
            <div className="text-[10px] uppercase tracking-widest text-[var(--melopa-gold)]">Admin Portal</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-navy mt-3">Sign in</h1>
        <div className="divider-gold" />
        <div className="grid gap-3">
          <div>
            <label className="label">Username</label>
            <input className="input" value={u} onChange={(e) => setU(e.target.value)} data-testid="login-username" required />
          </div>
          <div>
            <label className="label">Password</label>
            <input className="input" type="password" value={p} onChange={(e) => setP(e.target.value)} data-testid="login-password" required />
          </div>
          <button disabled={busy} className="btn-primary justify-center w-full" data-testid="login-submit">
            <LogIn className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
          </button>
          <label className="flex items-center gap-2 text-xs text-[var(--melopa-muted)] mt-1 cursor-pointer">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              data-testid="login-remember"
            />
            Keep me signed in on this device
          </label>
        </div>
      </form>
    </div>
  );
}
